<template>
  <div
    class="news-card-featured-wrapper"
    @click="navigateToNewsPost()"
  >
    <div class="row">
      <div class="col-12 col-md-6 pr-md-3">
        <img
          v-if="imgUrl"
          class="card-img mr-3"
          :src="imgUrl"
          alt="News image"
          @error="handleImgLoadError"
        />
        <img>
      </div>
      <div class="col-12 col-md-6 pt-md-0 pl-md-1 mt-n3 mt-md-0">
        <div class="news-card-body px-0">
          <news-card-details class="pb-1 pb-md-0" :date="postData.date" />
          <div class="pt-1">
            <h3 class="title">{{ postData.title }}</h3>
          </div>
          <div class="card-description" v-html="`${postData.description}...`"></div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import * as CONSTANTS from "@/store/constants";

import NewsCardDetails from "./NewsCardDetails";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";
import SharepointMixin from "@/mixins/SharepointMixin";

export default {
  name: "news-card-featured",
  props: ["postData"],
  mixins: [HomebaseMixpanelMixin, SharepointMixin],
  components: {
    NewsCardDetails,
  },
  data() {
    return {
      CONSTANTS,
      imgData: null,
      imgUrl: null,
    };
  },
  created() {
    this.initializeNewsCard();
  },
  methods: {
    async initializeNewsCard() {
      try {
        this.imgUrl = this.postData.imageUrl ? this.postData.imageUrl : "";
      } catch (e) {
        this.handleImgLoadError();
      }
    },

    navigateToNewsPost() {
      let title = this.postData.title;
      let url = this.postData.url;

      this.trackTopStoryClick(`${title} - ${url}`);
      window.open(url, Vue.prototype.$getAoneLinkTarget(url));
    },

    handleImgLoadError() {
      this.imgUrl = CONSTANTS.FALLBACK_ADSK_LOGO_IMG_URL;
    },
  },
};
</script>

<style scoped>
.news-card-featured-wrapper {
  color: #000 !important;
}
.news-card-featured-wrapper:hover {
  cursor: pointer;
  text-decoration: none !important;
}
.card-img {
  height: 200px;
  border-radius: 5px;
  object-fit: cover;
  object-position: 50% 35%;
}

.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media (min-width: 1200px) {
  .news-card-body {
    padding-top: 0px;
    margin-top: -4px;
  }
}
</style>
